import {createSupportWebformApi} from "./api";

export * from "webform/api/types";

export const supportWebformApi = createSupportWebformApi();
